export function timeout<T>(ms: number, promise: Promise<T>) {
  let cancel: () => void;
  const race = Promise.race([
    promise,
    new Promise<T>((res, rej) => setTimeout(rej, ms, "timeout")),
    new Promise<T>((res, rej) => {
      cancel = () => rej("cancel");
    }),
  ]);
  return Object.assign(race, { cancel });
}
